import React, { Component } from "react";

import { InputBoxWithState } from "../../../../../components/boda-boda/Forms";


class RouteFilterUI extends Component {
    render() {
        return (
            <div className="col-md-12">
                <div className="row">

                    <div className="col-md-6">
                        <InputBoxWithState
                            labelText="Route Name"
                            inputName={"name"}
                            formGroupName={this.props.searchFromKey}
                            placeHolderText={"Route Name"}
                            maxLength={20}
                        />
                    </div>

                </div>
            </div>
        )
    }
}

export default RouteFilterUI;
